// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1njGS","clinicsSelect":"styles_clinicsSelect__3aW_z"};